import {
  caseInsensitive293j1l8ok4b2v as caseInsensitive,
  CaseInsensitiveStringghw1fh6uf9mm as CaseInsensitiveString,
} from './Text.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DelegatingMutableSet198sgh8jelkh1 as DelegatingMutableSet } from './DelegatingMutableSet.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj($this$DelegatingMutableSet) {
  return $this$DelegatingMutableSet.c4n_1;
}
function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0($this$DelegatingMutableSet) {
  return caseInsensitive($this$DelegatingMutableSet);
}
function CaseInsensitiveMap$_get_entries_$lambda_r32w19($this$DelegatingMutableSet) {
  return new (Entry_0())($this$DelegatingMutableSet.r3().c4n_1, $this$DelegatingMutableSet.s3());
}
function CaseInsensitiveMap$_get_entries_$lambda_r32w19_0($this$DelegatingMutableSet) {
  return new (Entry_0())(caseInsensitive($this$DelegatingMutableSet.r3()), $this$DelegatingMutableSet.s3());
}
var CaseInsensitiveMapClass;
function CaseInsensitiveMap() {
  if (CaseInsensitiveMapClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.e4n_1 = LinkedHashMap().gc();
      }
      v2() {
        return this.e4n_1.v2();
      }
      v2o(key) {
        return this.e4n_1.x4(new (CaseInsensitiveString())(key));
      }
      x4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.v2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      w2o(key) {
        return this.e4n_1.z4(caseInsensitive(key));
      }
      z4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.w2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      s1() {
        return this.e4n_1.s1();
      }
      f5() {
        this.e4n_1.f5();
      }
      f4n(key, value) {
        return this.e4n_1.c5(caseInsensitive(key), value);
      }
      c5(key, value) {
        var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
        return this.f4n(tmp, !(value == null) ? value : THROW_CCE());
      }
      g4n(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.q3().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.collections.component1' call
          var key = element.r3();
          // Inline function 'kotlin.collections.component2' call
          var value = element.s3();
          this.f4n(key, value);
        }
      }
      e5(from) {
        return this.g4n(from);
      }
      h4n(key) {
        return this.e4n_1.d5(caseInsensitive(key));
      }
      d5(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.h4n((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      a5() {
        var tmp = this.e4n_1.a5();
        var tmp_0 = CaseInsensitiveMap$_get_keys_$lambda_ptzlqj;
        return new (DelegatingMutableSet())(tmp, tmp_0, CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0);
      }
      q3() {
        var tmp = this.e4n_1.q3();
        var tmp_0 = CaseInsensitiveMap$_get_entries_$lambda_r32w19;
        return new (DelegatingMutableSet())(tmp, tmp_0, CaseInsensitiveMap$_get_entries_$lambda_r32w19_0);
      }
      b5() {
        return this.e4n_1.b5();
      }
      equals(other) {
        var tmp;
        if (other == null) {
          tmp = true;
        } else {
          tmp = !(other instanceof CaseInsensitiveMap());
        }
        if (tmp)
          return false;
        return equals(other.e4n_1, this.e4n_1);
      }
      hashCode() {
        return hashCode(this.e4n_1);
      }
    }
    initMetadataForClass($, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap()]);
    CaseInsensitiveMapClass = $;
  }
  return CaseInsensitiveMapClass;
}
var EntryClass;
function Entry_0() {
  if (EntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.i4n_1 = key;
        this.j4n_1 = value;
      }
      r3() {
        return this.i4n_1;
      }
      s3() {
        return this.j4n_1;
      }
      hashCode() {
        return (527 + hashCode(ensureNotNull(this.i4n_1)) | 0) + hashCode(ensureNotNull(this.j4n_1)) | 0;
      }
      equals(other) {
        var tmp;
        if (other == null) {
          tmp = true;
        } else {
          tmp = !isInterface(other, Entry());
        }
        if (tmp)
          return false;
        return equals(other.r3(), this.i4n_1) && equals(other.s3(), this.j4n_1);
      }
      toString() {
        return toString(this.i4n_1) + '=' + toString(this.j4n_1);
      }
    }
    initMetadataForClass($, 'Entry', VOID, VOID, [Entry()]);
    EntryClass = $;
  }
  return EntryClass;
}
//region block: exports
export {
  CaseInsensitiveMap as CaseInsensitiveMap3bv985x2xrppt,
};
//endregion

//# sourceMappingURL=CaseInsensitiveMap.mjs.map
